// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Page} from '@pub/comp/page';
import {Text} from '@pub/comp/text';
import {Root_zone} from '@pub/features/root_zone';
import * as cns from './rootland.module.less';

export function Rootland(){
    return <Page className={cns.root}>
      <Text.xxxl h1>Rootland</Text.xxxl>
      <Root_zone/>
    </Page>;
}
